import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'
import { IsOptional } from 'class-validator'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'

export class WaterContaminationChartFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes: number[]

    @IsRequired()
    fieldCodes: number[]

    @IsRequired()
    regulationCode: number

    @IsOptional()
    dateRange?: IDateRangeFilter

    constructor(initialData?: Partial<WaterContaminationChartFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
